import { onboardingStepsLabels } from "../constants";
import type { OnboardingStep } from "../context/OnboardingContext";

/**
 * The 1-based position of a step in the onboarding, read from the step order
 * itself (`onboardingStepsLabels`) so the review never carries its own copy of
 * the numbers (freelancer-categories AC22): the next step added or moved shifts
 * them with no edit here.
 */
export const stepPosition = (step: OnboardingStep): number =>
  onboardingStepsLabels.findIndex((entry) => entry.step === step) + 1;
